
import { BaseModule, IModuleConfig } from '@kta20-core/interfaces/base-module';
import {IAppContext} from "@kta20-core/interfaces/i-app-context";
import {INavigationManager} from "@kta20-core/interfaces/i-navigation-manager";
import {ModuleViews} from "@kta20-ewo-definition/views/module-views";
import {MODULE_CLASS_NAME, ViewNames} from "@kta20-ewo-definition/constants";
import {NavigationManager} from "@kta20-ui-base/navigation-manager";

export class EwoDefinitionModuleConfig implements IModuleConfig {
    name: string = MODULE_CLASS_NAME;
}

export class EwoDefinitionModule extends BaseModule {
    static CLASS_NAME=MODULE_CLASS_NAME;

    static async factory(appContext: IAppContext, moduleConfig: EwoDefinitionModuleConfig): Promise<BaseModule> {

        console.log(appContext);
        console.log(moduleConfig);

        //TODO: replace to dynamically import the web/native concrete one
        // based on "appContext.platform"
        //I18nw.get().setSupportedLanguages(['en','it']);

        const navigationManager:INavigationManager = NavigationManager.get();

        //gets a concrete class from config since
        //there might be multiple implementations (web/mob)
        navigationManager.addViews(ModuleViews);

        //preloading this view to include it manually into the DOM
        //even without navigation
        await navigationManager.loadView(ViewNames.EWO_REPORTING_VIEW);
        await navigationManager.loadView(ViewNames.EWO_FORM_VIEW);
        await navigationManager.loadView(ViewNames.CRN_KNOWLEDGEBASE_VIEW);

        return new EwoDefinitionModule;
    };
}


